// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Exa1v","rootMobile":"styles_rootMobile__2GMR0"};